<template>
    <div  style="min-width: 100%;max-width: 1200px;background: #bfccd9;"  >
        <div class="footer">
            <div class="link">
                    <p>友情链接</p>
                    <div class="line1">
                        <a href="https://www.mem.gov.cn" title="中华人民共和国应急管理部">中华人民共和国应急管理部</a>
                        <a href="https://www.mem.gov.cn/awhsy_3512/" title="国务院安全生产委员会">国务院安全生产委员会</a>
                        <a href="https://www.nwserc.cn" title="国家安全生产应急救援中心">国家安全生产应急救援中心</a>
                        <a href="https://dctjfx.mem.gov.cn/aqscjb#/" title="安全生产举报系统">安全生产举报系统</a>
                        <a href="http://yjgl.gd.gov.cn" title="广东省应急管理厅">广东省应急管理厅</a>
                        <a href="http://yjglj.beijing.gov.cn" title="北京市应急管理局">北京市应急管理局</a>
                        <a href="https://yjgl.tj.gov.cn" title="天津市应急管理局">天津市应急管理局</a>
                        <a href="https://yjgl.hebei.gov.cn/portal/" title="河北省应急管理厅">河北省应急管理厅</a>
                        <a href="http://yjt.shanxi.gov.cn" title="山西省应急管理厅">山西省应急管理厅</a>
                        <a href="https://yjgl.ln.gov.cn" title="辽宁省应急管理厅">辽宁省应急管理厅</a>
                        <a href="http://yjt.jl.gov.cn" title="吉林省应急管理厅">吉林省应急管理厅</a>
                        <a href="http://yjgl.hlj.gov.cn" title="黑龙江省应急管理厅">黑龙江省应急管理厅</a>
                        <a href="http://yjglj.sh.gov.cn" title="上海市应急管理局">上海市应急管理局</a>
                        <a href="http://yjglt.jiangsu.gov.cn" title="江苏省应急管理厅">江苏省应急管理厅</a>
                        <a href="https://yjt.zj.gov.cn" title="浙江省应急管理厅">浙江省应急管理厅</a>
                        <a href="https://yjt.ah.gov.cn" title="安徽省应急管理厅">安徽省应急管理厅</a>
                        <a href="http://dgsafety.dg.gov.cn" title="百度">东莞市应急管理局</a>
                    </div>
            </div>
            <div class="detail">
                <div class="constList1">
                    <div class="constItem">
                        <p>购物指南</p>
                        <p @click="HandleHelp(33)">帮助中心</p>
                        <p>品牌中心</p>
                    </div>
                </div>
                <div class="constList1">
                    <div class="constItem">
                        <p>付款方式</p>
                        <p @click="HandleHelp(39)">付款开发票信息</p>
                        <p @click="HandleHelp(38)">如何支付</p>
                    </div>
                </div>
                <div class="constList1">
                    <div class="constItem">
                        <p>服务政策</p>
                        <p @click="HandleHelp(35)">配送服务</p>
                        <p @click="HandleHelp(36)">售后服务</p>
                        <p @click="HandleHelp(37)">隐私政策</p>
                    </div>
                </div>
                <div class="constList1">
                    <div class="constItem">
                        <p>内容中心</p>
                        <p @click="HandleListArticle(1829)">企链工大事件</p>
                        <p @click="HandleListArticle(1830)">客户之声</p>
                        <p @click="HandleListArticle(1831)">知识社区</p>
                    </div>
                </div>
                <div class="constList1">
                    <div class="constItem">
                        <p>关于我们</p>
                        <p @click="HandleHelp(40)">公司介绍</p>
                        <p @click="HandleHelp(41)">联系我们</p>
                        <p @click="HandleHelp(42)">加入我们</p>
                        <p>网站导航</p>
                    </div>
                </div>
                <div class="constList1">
                    <div class="constItem" style="border: none">
                        <p>关注我们</p>
                        <div class="imgBlock">
                            <div>
                                <img src="../../assets/ces2.jpg" alt="">
                            
                            </div>
                            <div>
                                <img src="../../assets/ces2.jpg" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                  
            </div>
            <div class="font">
                 
                    <p>广东众安皓宁科技有限公司</p>
                    <p style="margin-left: 20px;"><img src="../../assets/ces1.png" width="15px" alt="">粤ICP备2022123106号</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    methods: {
        HandleHelp(val){
            sessionStorage.setItem("helpMeunId",val)
            const { href } = this.$router.resolve({
                path: '/help/orders',
            });
            
            window.open(href, '_blank');
        },
        
        HandleListArticle(val){
            this.$router.push({
                path: '/help/content',
                query: {
                    id: val
                }
            })
            
        }
    },
    mounted(){
    }
}
</script>

<style scoped>
.footer{
    width: 1180px;
    margin: -10px auto;
    padding: 10px 10px;
    /* align-items: center; */
}
.link p{
    font-size: 22px;
    margin-top: 10px;
    margin-bottom: 8px;
    height: 35px;
    color: #56738f;
    font-weight: 600;
    padding-left: 10px;
}
.line1{
    line-height: 30px;
    padding-left: 10px;
    padding-bottom: 10px;
    color: #607f9f;
    font-size: 16px;
    border-bottom: 0.5px solid #c6d0db;
}
.line1 a{
    text-decoration: none;
    margin-right: 20px;
    color: #607f9f;
}


.constItem{
    margin: 10px 50px 0px 10px;
    padding-right: 10px;
    border-right: 1px solid #afbfcf;

}
.constItem p{
    line-height: 35px;
    color: #607f9f;
    cursor: pointer;
}
.constItem p:nth-child(1){
    color: #56738f ;
    font-size: 18px;
    font-weight: 500;
}
.imgBlock{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}


.constItem img{
    width: 150px;height: 150px;
    margin-right: 10px;
}
.font{
    background: #bfccd9;
    display: flex;
    justify-content: center;
    font-size: 16px;
    color: #56738f;
    margin-bottom: 30px;
}
@media screen and (min-width: 541px) {
    
    .detail{
        background: #bfccd9;
        height: 360px;
        font-size: 16px;
        display: flex;
        justify-content: flex-start;
        /* padding-top: 20px; */
        margin-top: 30px;
    } 
}

@media screen and (max-width: 540px) {
    .footer{
        width: 94%;
    }
    .font{
        font-size: 14px;
    }
    .detail{
        background: #bfccd9;
        /* height: 360px; */
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        flex-flow: row wrap;
        margin-top: 30px;
    }
    .constList1{
        margin-bottom: 20px;
    }
    .constItem{
        margin: 10px 30px 0px 10px;
        padding-right: 10px;
        border-right: 1px solid #afbfcf;

    }
    .constItem p:nth-child(1){
        font-size: 16px;
    }

    .imgBlock{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
}
</style>